'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'fish-fins';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4f2';
var svgPathData = 'M247.8 148c13.4-6.2 20.8-20.8 17.9-35.3L256 64 333.6 122.2c4.9 3.7 10.8 5.9 16.9 6.3 47.2 3.4 88 23.2 120.3 47.5 35.5 26.7 60.8 58.7 73.2 80-12.4 21.3-37.6 53.3-73.2 80-32.3 24.2-73.1 44.1-120.3 47.5-6.1 .4-12 2.6-16.9 6.3L256 448 265.7 399.4c2.9-14.5-4.5-29.1-17.9-35.3-17.1-7.9-32.7-17.6-46.6-28-13.8-10.4-26.1-21.6-36.8-32.8-10.2-10.7-26.5-13-39.3-5.5L32 352 77.8 271.9c5.6-9.8 5.6-21.9 0-31.8L32 160 125.1 214.3c12.8 7.5 29 5.2 39.3-5.5 10.7-11.2 23-22.4 36.8-32.8 13.9-10.5 29.6-20.2 46.6-28zM9.5 137.3C-.8 147.5-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.6 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3 15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8 39.2-29.4 67.2-64.7 81.6-89.5 5.8-9.9 5.8-22.2 0-32.1-14.4-24.8-42.5-60.1-81.6-89.5-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.6 4.9zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFishFins = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;